<div class="videoContainer">
	<div class="row nomargin nopadding" style="display: flex; align-items: center; justify-content: center">
		<div class="col-8 nomargin nopadding aspectRatio169" style="position: unset">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />
		</div>
	</div>
	<div class="row nomargin nopadding">
		<div class="col-4 nomargin nopadding aspectRatio169" style="position: unset">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
		</div>
		<div class="col-4 nomargin nopadding aspectRatio169" style="position: unset">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2" />
		</div>
		<div class="col-4 nomargin nopadding aspectRatio169" style="position: unset">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="3" />
		</div>
	</div>
</div>
<!--<div class="videoContainer">-->
<!--	<div class="bsssContainer">-->
<!--		<div class="bottomLeft">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0">-->
<!--			</sim-screen-container>-->
<!--		</div>-->
<!--		<div class="bottomCenter">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1">-->
<!--			</sim-screen-container>-->
<!--		</div>-->
<!--		<div class="bottomRIght">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2">-->
<!--			</sim-screen-container>-->
<!--		</div>-->
<!--		<div class="TopCenter">-->
<!--			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="3">-->
<!--			</sim-screen-container>-->
<!--		</div>-->
<!--	</div>-->
<!--</div>-->
